import {useEffect } from '../../InBuildImports';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navigation from '../../gjobhub/data/Navigation.json';
import GUploadResume from '../jobs/GUploadResume';
import CheckResume from '../jobs/CheckResume';
import TalendDashBoard from '../jobs/TADashBoard';
import GCandidatesgrid from './GCandidates-grid';
import GJobsIndex from './GJobsIndex';
import GJobSingle from './GJobSingle';
import GJobPost from '../jobs/GJobPost';
import GJobAboutUs from './GJobAboutUs';
import GEmployersSingle from './GEmployersSingle';
import GCandidateSingle from './GCandidateSingle';
import GlobalError from '../validation/GlobalError';
import GJobContactUs from './GJobContactUs';
import GHomePage1 from './GHomePage1';
import GServices from './GServices';
import GBrowseByCategory from './GBrowseByCategory';

function GJobsHubApp() {
 
const routes = [
  { path: Navigation.NAVIGATE_URL_GJOBSINDEX, element: <GJobsIndex/> },
    { path: Navigation.NAVIGATE_URL_GCANDIDATESGRID, element: <GCandidatesgrid/> },   
    { path: Navigation.NAVIGATE_URL_GUPLOADRESUME, element: <GUploadResume/> },
    { path: Navigation.NAVIGATE_URL_GCHECKRESUME, element: <CheckResume/> },
    { path: Navigation.NAVIGATE_URL_GJOBHUB, element: <GJobPost/> },
    { path: Navigation.NAVIGATE_URL_GJOBABOUTUS, element: <GJobAboutUs/> },
    { path: Navigation.NAVIGATE_URL_GJOBSINGLE, element: <GJobSingle/> },
    { path: Navigation.NAVIGATE_URL_GEMPLOYERSSINGLE, element: <GEmployersSingle/> },
    { path: Navigation.NAVIGATE_URL_GCANDIDATESINGLE, element: <GCandidateSingle/> },
    { path: Navigation.NAVIGATE_URL_GCANDIDATESGRID, element: <GCandidatesgrid/> },
    { path: Navigation.NAVIGATE_URL_GJOBCONTACTUS, element: <GJobContactUs/> },   
    { path: Navigation.NAVIGATE_URL_GHOMEPAGE, element: <GHomePage1/> }, 
    { path: Navigation.NAVIGATE_URL_GSERVICES, element: <GServices/> },
    { path: Navigation.NAVIGATE_URL_GSBROWSEBYCATERGORY, element: <GBrowseByCategory/> }, 

     { path: Navigation.NAVIGATE_URL_GLOBAL_ERROR, element: <GlobalError/> },
   
    ];
return (
    <BrowserRouter>
  <Routes>
            {routes.map((route, index) => (
              <Route key={index} path={route.path} element={route.element} />
            ))}  
             <Route path="/" element={<GJobsIndex />} />   
          </Routes>
</BrowserRouter>

)
}
export default GJobsHubApp;
